(function(){
  
  var loadScript = function(url, callback){

    var script = document.createElement("script");
    script.type = "text/javascript";

    if (script.readyState){ 
      script.onreadystatechange = function(){
        if (script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function(){
        callback();
      };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);

  };
  
/*
  var myAppJavaScript = function($){
    if ( $( "#FeatureRowImage-feature-row" ).length ){
      var imagen_src = $('#FeatureRowImage-feature-row').attr('srcset');
      //var coma = imagen_src.lastIndexOf(",");    //var loquequedasinfinal = imagen_src.substring(0, coma);
      //var ultimo = imagen_src.substring(coma);
      //var array = imagen_src.match(/(.*),(.*)/);
      //console.log(ultimo.replace(/[ ,]+/g, ""));
      //$('#shopify-section-feature-row .feature-row__item:first-child').css({'background-image':'url(' + ultimo.replace(/[ ,]+/g, "") + ')','background-size':'cover'});
      //$('#shopify-section-feature-row img').hide();
      //console.log('URL: ' + ultimo.trim());
    }
    if ( $( ".product-card__image-with-placeholder-wrapper" ).length ){
      $('.product-card__image-with-placeholder-wrapper').each(function(){
        //console.log('hola');
        $( this ).css({'border':'1px solid red'});
        var img_src = $( this ).find('img').attr('srcset');
        //console.log(img_src);
        var coma_imgs = img_src.lastIndexOf(",");
        var ultima = img_src.substring(coma_imgs);
        console.log(ultima.replace(/[ ,]+/g, ""));
        $( this ).css({'background-image':'url(' + ultima.replace(/[ ,]+/g, "") + ')','background-size':'cover'});
      });
	}
  };
*/
  
  var myAppJavaScript = function($){
  };
  
  
  if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
    loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
      jQuery191 = jQuery.noConflict(true);
      myAppJavaScript(jQuery191);
    });
  } else {
    myAppJavaScript(jQuery);
  }

})();